import { atom } from 'jotai'
import { Contact, ContactInstrument } from 'types/contacts'

export const contactAtom = atom<Contact>({} as Contact)
export const editingContactAtom = atom(false)
export const contactInstrumentAtom = atom<ContactInstrument>({} as ContactInstrument)
export const editingContactInstrumentAtom = atom(false)
